import React, { useState } from 'react';
import { ActionOperationType, ActionRef } from 'further-types/lp/action';
import { AllocationRule } from 'further-types/lp/allocations';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from 'further-ui/utils';
import AddBankFeeForm from './AddBankFeeForm';
import ReviewContent, { BankFee } from './ReviewContent';
import ErrorBoundary from 'components/ErrorBoundary';

type Props = {
  vehicleId: string;
  bankAccountId: string;
  bankOperation: {
    id: string;
    spent?: number;
    received?: number;
    accountCurrency: CurrencyCode;
    date: CalendarDay;
  };
  selectedTransactions: Array<{
    id: string;
    splitFromTransactionId?: string;
    unreconciledAmountTcy: number;
    operationType: ActionOperationType;
    currencyCode: CurrencyCode;
    actionRef: ActionRef;
    ledgerDate: CalendarDay;
  }>;
  onClose: () => void;
};

const defaultBankFee: BankFee = {
  amount: 0,
  vatRate: 0,
  description: '',
  allocationRule: AllocationRule.ByCommitmentAndClosingDate,
  allocations: [],
  currencyRate: null,
  customActionTypeId: null,
  customActionTypeName: null,
  fundingSource: null,
  commitmentStatus: null,
};

const Review: React.FC<Props> = ({
  vehicleId,
  bankAccountId,
  bankOperation,
  selectedTransactions,
  onClose,
}) => {
  const [showBankFeeForm, setShowBankFeeForm] = useState(false);
  const [bankFee, setBankFee] = useState(defaultBankFee);

  const handleToggleBankFeeForm = (initialAmount: number) => {
    setShowBankFeeForm((prev) => {
      setBankFee(
        prev ? defaultBankFee : { ...defaultBankFee, amount: initialAmount },
      );
      return !prev;
    });
  };

  return (
    <>
      {showBankFeeForm && (
        <AddBankFeeForm
          vehicleId={vehicleId}
          bankFee={bankFee}
          setBankFee={setBankFee}
          currency={bankOperation.accountCurrency}
          date={bankOperation.date}
          onRemove={() => handleToggleBankFeeForm(0)}
        />
      )}
      <ErrorBoundary>
        <ReviewContent
          vehicleId={vehicleId}
          bankAccountId={bankAccountId}
          bankOperation={bankOperation}
          selectedTransactions={selectedTransactions}
          onClose={onClose}
          bankFee={bankFee}
          showBankFeeForm={showBankFeeForm}
          onToggleBankFeeForm={handleToggleBankFeeForm}
        />
      </ErrorBoundary>
    </>
  );
};

export default Review;
